import { baseEnvironment } from './baseEnvironment';

export const environment = {
    ...baseEnvironment,
    apiUrl: 'https://api.traceeye-ce-dev.sato.co.jp/api',
    formatArchiveUrl: 'https://traceeye-ce-dev.sato.co.jp/',
};
